module.exports = __webpack_public_path__ + "img/sealburn.be516b0d.jpg";